<div (click)="onClick($event)" class="input-wrapper">
    <input
      #inputField
      class="input"
      [class.parenthesis]="parenthesis"
      [ngClass]="inputStyle"
      [class.required]="required && !value && !isNewInstance"
      [class.new-instance]="isNewInstance && !value"
      [class.top-icon-space]="topIconSvg || topIcon"
      [class.icon-space]="!!icon"
      [style.cursor]="cursorStyle"
      type="text"
      [value]="value"
      [attr.placeholder]="isFocused ? '' : _placeholder"
      [attr.maxlength]="maxLength"
      (input)="onChange($event)"
      (focus)="onFocusIn()"
      (focusout)="onFocusOut()"
    />
    <mat-icon *ngIf="icon" class="input-icon" [svgIcon]="icon"></mat-icon>
    <mat-icon *ngIf="topIcon" class="top-icon">{{ topIcon }}</mat-icon>
    <mat-icon *ngIf="topIconSvg" class="top-icon" [svgIcon]="topIconSvg"></mat-icon>
  </div>